module.exports = __webpack_public_path__ + "static/media/AluminBalconyTitle.f51d4097.jpeg";